import * as React from "react"
import {useTranslation} from "react-i18next";
import {convertPrice, handleSetQuery} from "../assets/js/main";
import {createSearchParams, Link, useLocation, useSearchParams} from "react-router-dom";
import {setLoading} from "../redux/loading/actions";
import {useDispatch, useSelector} from "react-redux";
import {setListReview} from "../redux/singleOrder/review/actions";
import {setListBox} from "../redux/multiOrder/infoBox/actions";
import {Backdrop, CircularProgress} from "@mui/material";
import {useSnackbar} from "notistack";
import HandleFetchData from "../plugin/HandleFetchData";
import {ThemeContext} from "../App";


export default function PaymentStatus() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t, i18n} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const [searchParams] = useSearchParams();
  const {fetchData} = HandleFetchData()
  const location = useLocation();
  const theme = React.useContext(ThemeContext)

  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const divarCallback = localStorage.getItem('d-callback')
  const divarIncomId = searchParams.get('state')

  React.useEffect(() => {
    getPaymentResult()
    dispatch(setListReview([]))
    dispatch(setListBox([]))
  }, [])

  const [orderStatus, setOrderStatus] = React.useState(null)

  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));

  const getPaymentResult = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', `/getOrderInfo?orderId=${searchParams.get('OrderId')}`, '',
       "application/json", '', '',''
    )
    setOrderStatus(fetch?.data)
    dispatch(setLoading(false))
  }

  const handlerDownload = async (id) => {
    dispatch(setLoading(true))
    var pdfUrl = `https://postex.ir/api/order/getpdfinvoice/${id}`; // Replace with the actual PDF URL
    var myHeaders = new Headers();
    myHeaders.append("token", localStorage.getItem('token'));

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(pdfUrl, requestOptions)
       .then(response => response.blob())
       .then(blob => {
         dispatch(setLoading(false))
         var link = document.createElement('a');
         link.href = window.URL.createObjectURL(blob);
         link.download = `${+new Date()}.pdf`;
         link.click();
       })
       .catch(error => {
         console.log('error', error)
         dispatch(setLoading(false))
       });
  }

  return (
     <>

       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       <div className="paymentStatusPage">

         <div style={{visibility: "hidden", opacity: "0"}} id="paymentDown"/>

         <div className="container">
           <div className="logo">
             <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt=""/>
           </div>

           <div className="body-page">
             <div className="status-icon">

               {
                 searchParams.get('code') == 0 ?
                    <svg width="100" height="100" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M62 0C27.7595 0 0 27.7498 0 62C0 96.2502 27.7595 124 62 124C96.2405 124 124 96.2332 124 62C124 27.7668 96.2405 0 62 0Z" fill="#2AD352"/>
                      <path
                         d="M-1.49015e-05 62.0001C-0.0140107 72.2481 2.52375 82.3384 7.38428 91.3605C13.5767 93.1786 19.9979 94.0994 26.4517 94.0948C63.7244 94.0948 93.9397 63.8795 93.9397 26.6068C93.9452 20.0507 92.9956 13.5287 91.1206 7.24634C82.1576 2.47215 72.1552 -0.0168256 62 8.56037e-05C27.7595 8.56037e-05 -1.49015e-05 27.7499 -1.49015e-05 62.0001Z"
                         fill="#74DA7F"/>
                      <path
                         d="M97.3594 51.7261L60.094 90.8612C59.0784 91.9266 57.8583 92.776 56.5066 93.3586C55.1549 93.9413 53.6996 94.2451 52.2277 94.2518H52.1793C50.7156 94.2522 49.2668 93.9585 47.9188 93.3881C46.5709 92.8177 45.3512 91.9823 44.3324 90.9314L24.5578 70.5635C23.5361 69.5379 22.7282 68.3196 22.1811 66.9792C21.634 65.6389 21.3586 64.2033 21.3708 62.7556C21.383 61.308 21.6826 59.8772 22.2522 58.5463C22.8218 57.2154 23.65 56.0109 24.6889 55.0026C25.7278 53.9944 26.9565 53.2025 28.3039 52.673C29.6513 52.1435 31.0904 51.8868 32.5377 51.9179C33.9851 51.949 35.4118 52.2673 36.7352 52.8543C38.0585 53.4412 39.2521 54.2852 40.2467 55.3371L52.1018 67.5482L81.5252 36.65C82.5108 35.5931 83.6962 34.7421 85.0128 34.1463C86.3295 33.5504 87.7512 33.2215 89.1957 33.1786C90.6402 33.1357 92.0789 33.3797 93.4286 33.8963C94.7782 34.413 96.0121 35.1921 97.0587 36.1886C98.1053 37.1852 98.944 38.3793 99.5262 39.702C100.108 41.0247 100.423 42.4498 100.451 43.8947C100.478 45.3396 100.22 46.7757 99.6891 48.1199C99.1585 49.4641 98.3667 50.6899 97.3594 51.7261Z"
                         fill="white"/>
                    </svg>
                    :
                    <svg width="100" height="100" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M63 0C28.2073 0 0 28.2048 0 63C0 97.7952 28.2073 126 63 126C97.7927 126 126 97.7927 126 63C126 28.2073 97.7927 0 63 0Z" fill="#DD4247"/>
                      <path
                         d="M29.6689 98.6394C67.4763 98.6394 98.1248 67.9909 98.1248 30.1859C98.1307 22.8135 96.944 15.4886 94.6106 8.49523C85.0115 2.9151 74.103 -0.0164817 62.9998 6.96986e-05C28.2071 6.96986e-05 -0.000173579 28.2073 -0.000173579 63.0001C-0.0173313 74.4391 3.09486 85.665 8.99947 95.4623C15.6859 97.5738 22.657 98.6453 29.6689 98.6394Z"
                         fill="#E55353"/>
                      <path
                         d="M89.0047 89.0051C87.6955 90.3136 85.9203 91.0486 84.0693 91.0486C82.2183 91.0486 80.4431 90.3136 79.1339 89.0051L63 72.8712L46.8661 89.0051C45.5569 90.3136 43.7817 91.0486 41.9307 91.0486C40.0797 91.0486 38.3045 90.3136 36.9953 89.0051C35.6868 87.6959 34.9518 85.9207 34.9518 84.0697C34.9518 82.2187 35.6868 80.4435 36.9953 79.1343L53.1292 63.0004L36.9953 46.8665C35.6868 45.5573 34.9518 43.782 34.9518 41.9311C34.9518 40.0801 35.6868 38.3049 36.9953 36.9957C38.3045 35.6872 40.0797 34.9521 41.9307 34.9521C43.7817 34.9521 45.5569 35.6872 46.8661 36.9957L63 53.1296L79.1339 36.9957C80.4431 35.6872 82.2183 34.9521 84.0693 34.9521C85.9203 34.9521 87.6955 35.6872 89.0047 36.9957C90.3132 38.3049 91.0482 40.0801 91.0482 41.9311C91.0482 43.782 90.3132 45.5573 89.0047 46.8665L72.8708 63.0004L89.0047 79.1343C90.3132 80.4435 91.0482 82.2187 91.0482 84.0697C91.0482 85.9207 90.3132 87.6959 89.0047 89.0051Z"
                         fill="white"/>
                    </svg>
               }
             </div>

             <div className="status-text">
               {
                 searchParams.get('code') == 0 ?
                    <h4>{t("paymentStatus.t1")}</h4>
                    :
                    <h4>{t("paymentStatus.t2")}</h4>
               }
             </div>

             <div className="status-list">
               <div className="item">
                 <span>{t("paymentStatus.t3")}</span>
                 <p>  {orderStatus?.orderTotal ? convertPrice(orderStatus?.orderTotal) + ' ' + t("paymentStatus.t4") : '-' + ' ' + t("paymentStatus.t4")} </p>
               </div>
               <div className="item">
                 <span>{t("paymentStatus.t5")}</span>
                 <p>{orderStatus?.orderId}</p>
               </div>
               {
                 searchParams.get('code') == 0 && <div className="item">
                   <span>{t("paymentStatus.t6")}</span>
                   <p>{orderStatus?.TrackingNumbers[0]}</p>
                 </div>
               }
               {/*<div className="item">*/}
               {/*  <span>{t("paymentStatus.t7")}</span>*/}
               {/*  <p>{convertDate(orderStatus?.orderDate)}</p>*/}
               {/*</div>*/}
             </div>

             <div className="action-1">
               {
                 searchParams.get('code') == 0 ?
                    <>
                      <div className="btnGroup_yellow" style={{justifyContent: 'center', margin: '10px'}}>
                        <Link to={{pathname: '/singleOrder', search: searchParams.get('state') &&  createSearchParams({
                            state: searchParams.get('state')}).toString()
                        }} type="button" className="btnFill" style={{marginBottom: '0'}} id="singleOrder">
                          <span>{t("paymentStatus.t8")}</span>
                        </Link>
                      </div>
                      <div className="btnGroup_light" style={{justifyContent: 'center', margin: '10px'}}>
                        <Link to={{pathname: '/tracking', search: searchParams.get('state') &&  createSearchParams({
                            state: searchParams.get('state')}).toString()
                        }} type="button" className="btnEmpty mb-0" id="tracking">
                          <span>{t("paymentStatus.t9")}</span>
                        </Link>
                      </div>

                    </>
                    :
                    <div className="btnGroup_light" style={{justifyContent: 'center', margin: '10px'}}>
                    <Link to={{pathname: '/singleOrder', search: searchParams.get('state') && createSearchParams({
                        state: searchParams.get('state')}).toString()
                    }} type="button" className="btnEmpty m-0" id="singleOrder">{t("paymentStatus.t10")}</Link>
                    </div>
               }
               {
                 divarIncomId && divarIncomId !== 'null' &&
                 <div className="btn-divar" style={{justifyContent: 'center', margin: '10px'}}>
                   <a href={divarCallback} className="btnFill d-flex justify-content-center" id="divarCallback">
                     <span>{t("paymentStatus.t13")}</span>
                     <img src={require('../assets/img/divar.png')} alt="divar"/>
                   </a>
                 </div>
               }

             </div>


             {
               searchParams.get('code') == 0 && <div className="action-2">
                 <button type="button" onClick={() => handlerDownload(orderStatus?.orderId)} id="handlerDownload">
                   {t("paymentStatus.t11")}
                   <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M24.7559 5.80078V4.39453C24.7559 1.97139 22.7845 0 20.3613 0H9.58008C7.15693 0 5.18555 1.97139 5.18555 4.39453V5.80078H24.7559Z" fill="#C4C4C4"/>
                     <path
                        d="M6.94336 18.6914V25.8398V27.3633V28.2422C6.94336 29.213 7.73033 30 8.70117 30H21.2402C22.2111 30 22.998 29.213 22.998 28.2422V27.3633V25.8398V18.6914H6.94336ZM17.3145 26.1914H12.627C12.1416 26.1914 11.748 25.7979 11.748 25.3125C11.748 24.8271 12.1416 24.4336 12.627 24.4336H17.3145C17.7998 24.4336 18.1934 24.8271 18.1934 25.3125C18.1934 25.7979 17.7998 26.1914 17.3145 26.1914ZM17.3145 22.4414H12.627C12.1416 22.4414 11.748 22.0479 11.748 21.5625C11.748 21.0771 12.1416 20.6836 12.627 20.6836H17.3145C17.7998 20.6836 18.1934 21.0771 18.1934 21.5625C18.1934 22.0479 17.7998 22.4414 17.3145 22.4414Z"
                        fill="#C4C4C4"/>
                     <path
                        d="M25.5762 7.55859H4.42383C2.00068 7.55859 0.0292969 9.52998 0.0292969 11.9531V18.9844C0.0292969 21.4075 2.00068 23.3789 4.42383 23.3789H5.18555V18.6914H4.6582C4.17281 18.6914 3.7793 18.2979 3.7793 17.8125C3.7793 17.3271 4.17281 16.9336 4.6582 16.9336H6.06445H23.877H25.2832C25.7686 16.9336 26.1621 17.3271 26.1621 17.8125C26.1621 18.2979 25.7686 18.6914 25.2832 18.6914H24.7559V23.3789H25.5762C27.9993 23.3789 29.9707 21.4075 29.9707 18.9844V11.9531C29.9707 9.52998 27.9993 7.55859 25.5762 7.55859ZM7.4707 13.0664H4.6582C4.17281 13.0664 3.7793 12.6729 3.7793 12.1875C3.7793 11.7021 4.17281 11.3086 4.6582 11.3086H7.4707C7.95609 11.3086 8.34961 11.7021 8.34961 12.1875C8.34961 12.6729 7.95609 13.0664 7.4707 13.0664Z"
                        fill="#C4C4C4"/>
                   </svg>
                 </button>
               </div>
             }
           </div>

         </div>

       </div>
     </>
  )
}
